import { Component, effect, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

import { ConsentService } from '../services/consent.service';

/**
 * First-run cookie banner plus a "Cookie preferences" modal. The banner shows
 * until the user makes a choice; the modal can be reopened anytime (footer link)
 * to change it. Necessary cookies are always on; Analytics and Marketing are
 * opt-in. Trackers read ConsentService and only initialise once granted.
 */
@Component({
  selector: 'app-consent-banner',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './consent-banner.component.html'
})
export class ConsentBannerComponent {
  protected readonly consent = inject(ConsentService);

  /** Local toggle state for the modal, seeded from saved consent when it opens. */
  protected readonly analytics = signal(false);
  protected readonly marketing = signal(false);

  private readonly _seed = effect(() => {
    if (this.consent.prefsOpen()) {
      const s = this.consent.snapshot();
      this.analytics.set(s.analytics);
      this.marketing.set(s.marketing);
    }
  }, { allowSignalWrites: true });

  protected saveChoices(): void {
    this.consent.save({ analytics: this.analytics(), marketing: this.marketing() });
  }
}
